import { render, staticRenderFns } from "./ConfirmDeleteNewsDialog.vue?vue&type=template&id=eb756dea"
import script from "./ConfirmDeleteNewsDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDeleteNewsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports